var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEntrar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-528 -528)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Entrar",
    transform: "translate(528 528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 23h18a1.5 1.5 0 0 1 0 3h-18a1.5 1.5 0 0 1 0-3zm8-20H19a1.5 1.5 0 0 1 0 3h-1.5a1.5 1.5 0 0 1 0-3zm0 39H19a1.5 1.5 0 0 1 0 3h-1.5a1.5 1.5 0 0 1 0-3z",
    id: "Shape",
    fill: "#3F3E3E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 43.5h14.96a6.5 6.5 0 0 0 6.5-6.5V11a6.5 6.5 0 0 0-6.5-6.5H18.492",
    id: "Shape",
    stroke: "#3F3E3E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    stroke: "#3F3E3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M22 16l7 8.5-7 8.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrar);
export default __webpack_public_path__ + "static/media/entrar.ea9e696d90f9965623f0bf1843e47bd7.svg";
export { ForwardRef as ReactComponent };